module.exports = __webpack_public_path__ + "img/3.ed8a6420.png";